var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"custom-btn",attrs:{"target":"_blank","href":"https://apps.apple.com/us/app/dr-kegel-for-mens-health/id1470065487"}},[_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }